export const HIGH_QUALITY_VIDEO_ID = '31a913e5-238e-4903-b6ab-20932474a57d'

export const STANDARD_QUALITY_VIDEO_ID = '959fb6bf-9d3f-4036-936d-38b6a9021d1c'
